// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2OMfs","unreadBadge":"styles_unreadBadge__23CIF","modalContent":"styles_modalContent__JNyvv","modal":"styles_modal__238Y_"};